import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { selectClienteTarget, obtenerHabitacionesContratadas, obtenerClienteItemsPaqueteAction } from "../../../ducks/clientesDuck"
import handleRenderOption from "./handleRenderOption"
import { useParams } from "react-router-dom"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { useEffect } from "react"
const InitialValueCliente = {
    referencia: "",
    idCotizacion: 0,
    cliente: {},
}

const CbClientes = () => {
    const { clientes } = useSelector(store => store.cliente)
    const dispatch = useDispatch()
    const { referencia } = useParams()
    const getOptionHangle = (event, valor) => {
        if (valor) {
            dispatch(onLoadAnction({ message: "" }))
            dispatch(selectClienteTarget({ cliente: valor, referencia: valor.Movimiento?.Referencia })).then(Response => {
                dispatch(obtenerHabitacionesContratadas({ Referencia: valor.Movimiento?.Referencia }))
                dispatch(obtenerClienteItemsPaqueteAction({ IdPaquete: valor?.paquete?.Id_Paquete, referencia: valor.Movimiento?.Referencia }))
                dispatch(offLoadAction())
            })
        } else {
            dispatch(selectClienteTarget({ cliente: InitialValueCliente, referencia: InitialValueCliente.referencia }))
            dispatch(obtenerHabitacionesContratadas({ Referencia: "0" }))
        }
    }

    useEffect(() => {
        const clienteOnline = () => {
            dispatch(onLoadAnction({ message: "" }))
            const valor = clientes.find(item => item.Movimiento?.Referencia === referencia)
            if (valor) {
                dispatch(selectClienteTarget({ cliente: valor, referencia: valor.Movimiento?.Referencia })).then(Response => {
                    dispatch(obtenerHabitacionesContratadas({ Referencia: valor.Movimiento?.Referencia }))
                    dispatch(obtenerClienteItemsPaqueteAction({ IdPaquete: valor?.paquete?.Id_Paquete, referencia: valor.Movimiento?.Referencia }))
                    dispatch(offLoadAction())
                })
            } else {
                dispatch(offLoadAction())
            }
        }
        if (clientes.length > 0 && referencia)
            clienteOnline()
    }, [dispatch, clientes, referencia])

    return (
        <div style={{ margin: "2% 0" }}>
            <Autocomplete
                id={`id-auto-Clientes`}
                options={clientes.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    let nombre = option?.Titular ?? `${option.Movimiento?.Cuenta?.Nombre.trim()} ${option.Movimiento?.Cuenta?.Apellido_Paterno.trim()}`
                    return `${option.Movimiento?.Referencia} - ${option.paquete?.Nombre} - ${nombre}`
                }}
                style={{
                    width: "97%",
                    margin: "2% 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={clientes.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Clientes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="clientes"
                    />
                )}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default CbClientes